var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.departmentClass,attrs:{"to":_vm.fileLink},nativeOn:{"click":function($event){return _vm.$emit('navigated')}}},[_vm._v(_vm._s(_vm.file.referenceLong))])}
var staticRenderFns = []

export { render, staticRenderFns }